<grid-ui-loading class="loading" message="Loading" [messagePosition]="'right'" [fontSize]="'small'"> </grid-ui-loading>
